<ng-container>
	<mat-card (cdkDragEnded)="_dragEnd($event);" (mousedown)="_mouseDown($event);" [cdkDragFreeDragPosition]="position"
			  [ngStyle]="_visible()"
			  cdkDrag
			  cdkDragBoundary=".desktop"
			  class="drag-box panel"
			  style="width: fit-content;">
		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" cdkDragHandle fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-clear-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>
		<mat-card-content class="panel-content" style="width: fit-content;">
			<div *ngIf="locked" cdkDragHandle></div>
			<div fxLayout="row" style="width: fit-content;">
				<div *ngIf="lineCharts.length > 0; else noData" fxLayout="column">

					<div *ngIf="!locked" cdkDragHandle fxLayout="column" style="width: fit-content;">
						<div class="top-buttons" fxLayout="row">
							<div *ngFor="let index of [0,1,2,3,4,5,6,7]" fxLayout="column">
								<button (click)="selected = index" class="top-button" color="primary" mat-button id="mat-data-button">{{nthChartData(index).name}}</button>
								<div [ngStyle]="underLine(index)"></div>
							</div>
						</div>
						<ngx-charts-line-chart (select)="onSelect($event)" (window:resize)="onResize($event)"
											   [animations]="false"
											   [autoScale]="true"
											   [curve]="lineChartLineInterpolation"
											   [gradient]="true"
											   [legend]="true"
											   [ngClass]="modename"
											   [ngStyle]="modestyle"
											   [results]="chartData.data"
											   [scheme]="lineChartColorScheme"
											   [showXAxisLabel]="true"
											   [showYAxisLabel]="true"
											   [view]="size"
											   [xAxisLabel]="chartData.lineChartXAxisLabel"
											   [xAxis]="true"
											   [yAxisLabel]="chartData.lineChartYAxisLabel"
											   [yAxis]="true"
											   [yScaleMax]="chartData.yScaleMax"
											   [yScaleMin]="chartData.yScaleMin"
											   fxFlex
											   fxLayoutAlign="center"
											   legendTitle=""
											   tooltipDisabled="true">
						</ngx-charts-line-chart>
					</div>

					<div *ngIf="locked" fxLayout="column" style="width: fit-content;">
						<div class="top-buttons" fxLayout="row">
							<div *ngFor="let index of [0,1,2,3,4,5,6,7]" fxLayout="column">
								<button (click)="selected = index" class="top-button" color="primary" mat-button id="mat-chart-data-button">{{nthChartData(index).name}}</button>
								<div [ngStyle]="underLine(index)"></div>
							</div>
						</div>
						<ngx-charts-line-chart (select)="onSelect($event)" (window:resize)="onResize($event)"
											   [animations]="false"
											   [autoScale]="true"
											   [curve]="lineChartLineInterpolation"
											   [gradient]="true"
											   [legend]="true"
											   [ngClass]="modename"
											   [ngStyle]="modestyle"
											   [results]="chartData.data"
											   [scheme]="lineChartColorScheme"
											   [showXAxisLabel]="true"
											   [showYAxisLabel]="true"
											   [view]="size"
											   [xAxisLabel]="chartData.lineChartXAxisLabel"
											   [xAxis]="true"
											   [yAxisLabel]="chartData.lineChartYAxisLabel"
											   [yAxis]="true"
											   [yScaleMax]="chartData.yScaleMax"
											   [yScaleMin]="chartData.yScaleMin"
											   fxFlex
											   fxLayoutAlign="center"
											   legendTitle=""
											   tooltipDisabled="true">
						</ngx-charts-line-chart>
					</div>

				</div>
				<mat-slider (change)="sliderChange()" [(ngModel)]="factor" [max]="sliderMax" [min]="sliderMin" [step]="sliderStep" invert="true" thumbLabel="true" vertical="true"></mat-slider>
			</div>
			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>
</ng-container>
